var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isMobileLandscape
    ? _c(
        "div",
        { staticClass: "footer-wrapper" },
        [
          _c("Logo"),
          _c("div", { staticClass: "menu-btn" }, [
            _c(
              "div",
              { staticClass: "balance relative" },
              [
                _vm._v(" " + _vm._s(_vm.currencySymbol) + " "),
                _c("animated-amount", {
                  attrs: {
                    value: _vm.balance,
                    formatValue: _vm.formatAmount,
                    duration: 500,
                  },
                }),
                _c("Transition", { attrs: { name: "fade" } }, [
                  _vm.futureDiff
                    ? _c("div", { staticClass: "furture-diff" }, [
                        _vm._v("+ " + _vm._s(_vm.userFutureDiff)),
                      ])
                    : _vm._e(),
                ]),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "burger-menu" },
              [!_vm.isPopupOpen ? _c("BurgerMenu") : _vm._e()],
              1
            ),
          ]),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }